
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQSection from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';
function Punetomahabaleshwarurbania() {



    const cardData =
    {
        keyword: '  Pune to Mahabaleshwar Urbania On Rent',
        heading: 'Samarth Travels: Pune to Mahabaleshwar Urbania On Rent',
        headingDescription: 'Samarth Travels offers Urbania on rent from Pune to Mahabaleshwar, perfect for family trips, weekend getaways, and group travel. Our premium Force Urbania vehicles are equipped with air-conditioning, push-back seats, and spacious interiors to ensure a smooth and comfortable journey through the scenic Western Ghats. With skilled drivers, fair pricing, and a commitment to customer satisfaction, Samarth Travels makes your Pune to Mahabaleshwar travel memorable and hassle-free.',

        top: 'Top Places to Visit in Pune with Samarth Travels',

       "topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Shaniwar Wada is a majestic 18th-century fortification located in the heart of Pune. Once the seat of the powerful Peshwas of the Maratha Empire, it is renowned for its historical significance, massive gateways, and intriguing legends, including ghost stories tied to its mysterious past. Despite being partially destroyed by fire, the remaining structures, especially the Delhi Gate and the fort’s expansive garden layout, provide a fascinating glimpse into Maratha architecture and political history."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Built in 1892 by Sultan Aga Khan III, this sprawling palace is an architectural gem and a key monument in India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The palace features Italian arches, sprawling gardens, and houses a museum that contains personal belongings of Gandhi and historical photographs. It is also the final resting place of Kasturba Gandhi and Mahadev Desai, adding to its solemn importance."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Located about 30 kilometers from Pune, Sinhagad Fort sits atop the Sahyadri mountains and is a favorite trekking destination for locals and tourists alike. With a history dating back over a thousand years, the fort was famously the site of the battle between the Marathas and the Mughals in 1670. Visitors are drawn to its rugged beauty, crumbling fortifications, and sweeping views of the surrounding valleys, especially during monsoons when the hills are lush green and covered in mist."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "This 8th-century rock-cut temple is carved entirely from a single basalt rock and dedicated to Lord Shiva. Nestled quietly amidst urban Pune, Pataleshwar offers a striking contrast to the city’s bustle. It features a circular Nandi Mandapa and intricately carved columns and sanctums. A protected monument under the Archaeological Survey of India, it’s a peaceful retreat and an excellent example of early Indian rock architecture."
    },
    {
      "title": "Dagdusheth Halwai Ganpati Temple",
      "description": "One of the most famous Ganesh temples in India, Dagdusheth Halwai Ganpati Temple attracts millions of devotees every year, especially during Ganesh Chaturthi. The temple’s grand idol of Lord Ganesh is adorned with gold and jewelry, symbolizing prosperity and devotion. Built by a sweetmaker in the 1800s, the temple also engages in numerous social and cultural initiatives, making it both a religious and community hub."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "Founded by Dr. Dinkar Kelkar in memory of his son, this museum is a treasure trove of Indian heritage. It houses over 20,000 artifacts, including musical instruments, ancient utensils, sculptures, paintings, and even quirky items like betel nut crackers and door frames. The collection offers insight into the daily lives and traditions of Indians across centuries, and its carefully curated exhibits make it a cultural landmark in Pune."
    },
    {
      "title": "Parvati Hill and Temple",
      "description": "Parvati Hill is one of Pune’s oldest heritage sites and offers a combination of spiritual serenity and scenic views. Climbing 103 steps leads to a temple complex dedicated to Goddess Parvati and Lord Shiva. The hill also hosts a small museum, Peshwa-era relics, and panoramic views of the cityscape below, making it ideal for morning walks and peaceful contemplation."
    },
    {
      "title": "Osho Ashram",
      "description": "Located in the serene and green Koregaon Park area, the Osho International Meditation Resort is a global center for spiritual seekers. It offers dynamic meditation sessions, wellness therapies, and luxurious facilities in a Zen-like atmosphere. Known for attracting international visitors, the ashram promotes mindfulness, inner peace, and holistic living through Osho’s teachings."
    },
    {
      "title": "Pune Okayama Friendship Garden",
      "description": "Inspired by the 300-year-old Okayama Korakuen Garden in Japan, this beautifully landscaped space—also known as Pu La Deshpande Garden—is perfect for nature lovers and photographers. The garden features flowing streams, lush lawns, bridges, and seasonal flowers, offering a tranquil escape right in the city. It’s ideal for evening walks and peaceful getaways."
    },
    {
      "title": "Katraj Snake Park and Rajiv Gandhi Zoological Park",
      "description": "Spread over 130 acres, this complex features a zoo, snake park, and animal rescue center. The snake park houses over 160 species of snakes, including cobras and pythons, while the zoo includes tigers, leopards, elephants, and more. Educational exhibits make it an informative and fun spot for children and families, combining entertainment with awareness about wildlife conservation."
    }
  ],

"services": [
    {
        "name": "Pune to Mahabaleshwar Urbania on Rent",
        "description": "Samarth Travels offers Urbania on rent for Pune to Mahabaleshwar travel, perfect for families, friends, or corporate groups planning a getaway. Our vehicles provide comfort and safety throughout the 120+ km journey, ensuring you reach the scenic hill station feeling refreshed. With spacious interiors and experienced drivers familiar with the route, we make your trip seamless from start to finish."
    },
    {
        "name": "Urbania Rental for Pune to Mahabaleshwar Trip",
        "description": "Make your Pune to Mahabaleshwar journey more enjoyable with our Urbania rental services. Samarth Travels provides well-maintained, air-conditioned vans equipped with reclining seats, ample luggage space, and smooth suspension—ideal for long road trips. Whether it's a weekend escape or a planned holiday, our rentals ensure comfort and convenience throughout the trip."
    },
    {
        "name": "Urbania 14-Seater on Rent for Mahabaleshwar",
        "description": "Travel as a group with our 14-seater Urbania rental for Mahabaleshwar trips from Pune. This vehicle is ideal for medium-sized groups looking for comfort, space, and affordability. With features like individual AC vents, large windows for scenic views, and reliable service, your road trip to the hills becomes an enjoyable part of the holiday experience."
    },
    {
        "name": "Urbania for Mahabaleshwar Trip from Pune",
        "description": "Heading to Mahabaleshwar? Rent an Urbania from Pune with Samarth Travels for a relaxed and scenic ride. Perfect for group tours, family vacations, or photography expeditions, our Urbania vans offer both comfort and dependability. With trained drivers and vehicle tracking options, your trip to the Western Ghats will be safe, timely, and memorable."
    },
    {
        "name": "Pune to Mahabaleshwar Urbania Hire",
        "description": "Samarth Travels provides Urbania hire services from Pune to Mahabaleshwar, perfect for travelers who value comfort and reliability. Our vehicles are equipped with modern amenities like air-conditioning, music systems, and cushioned seats. Enjoy door-to-door pickup and drop service along with flexible rental durations tailored to your travel plan."
    },
    {
        "name": "Urbania for Group Travel to Mahabaleshwar from Pune",
        "description": "Plan your group travel from Pune to Mahabaleshwar with ease by booking our Urbania vans. Whether you’re a college group, corporate team, or extended family, our spacious vehicles accommodate everyone comfortably. Enjoy scenic stops, flexible itineraries, and safe driving with our trusted drivers. Group travel has never been this fun and convenient!"
    },
    {
        "name": "Rent Urbania for Mahabaleshwar Sightseeing Tour",
        "description": "Explore the scenic beauty of Mahabaleshwar with our Urbania rental designed for sightseeing tours. Visit top attractions like Arthur’s Seat, Venna Lake, and Mapro Garden in comfort. Our vans come with knowledgeable drivers who can suggest the best routes and hidden gems, making your trip both comfortable and enriching."
    },
    {
        "name": "Urbania on Rent Pune to Mahabaleshwar",
        "description": "Looking for reliable and comfortable transportation from Pune to Mahabaleshwar? Book an Urbania van with Samarth Travels. Our vans are perfect for long-distance travel, offering ample space, air-conditioning, and smooth rides. Whether it’s a family vacation or an office retreat, we make the journey just as enjoyable as the destination."
    },
    {
        "name": "Urbania Rental Price Pune to Mahabaleshwar",
        "description": "Curious about Urbania rental prices from Pune to Mahabaleshwar? Samarth Travels offers competitive and transparent pricing with no hidden charges. Rates vary based on vehicle type, duration, and trip customization. Enjoy top-quality service, well-maintained vehicles, and great value for your money. Get a quote tailored to your itinerary today!"
    },
    {
        "name": "Rent Urbania for Mahabaleshwar Family Trip",
        "description": "Make your next family trip to Mahabaleshwar extra special with Samarth Travels’ Urbania rentals. Our vans are designed to keep families together during travel, offering safety, entertainment, and comfort. From grandparents to kids, everyone will enjoy the scenic drive from Pune to Mahabaleshwar with our courteous drivers and smooth vehicles."
    },
    {
        "name": "Pune to Mahabaleshwar Urbania Rental Package",
        "description": "Enjoy the convenience of our all-inclusive Urbania rental packages for trips from Pune to Mahabaleshwar. Our packages include vehicle, driver, fuel, and tolls for a stress-free travel experience. Customize your package to include sightseeing stops, multi-day returns, or luxury add-ons. Perfect for weekend trips, family vacations, or romantic getaways."
    },
    {
        "name": "Urbania Hire for Mahabaleshwar Tour from Pune",
        "description": "Hire an Urbania van for your Mahabaleshwar tour from Pune with Samarth Travels. Our service includes punctual pickup, experienced drivers, and a clean, well-equipped vehicle for a premium travel experience. Whether you're planning a one-day trip or a weekend tour, we tailor the rental to suit your needs and schedule."
    },
    {
        "name": "Mahabaleshwar Trip Urbania on Rent",
        "description": "Planning a Mahabaleshwar trip? Rent an Urbania from Samarth Travels and enjoy a comfortable, scenic, and memorable journey. Our Urbania vans are ideal for groups, offering plenty of legroom, large luggage compartments, and smooth highway performance. Travel together, create memories, and explore the best of Mahabaleshwar with complete peace of mind."
    }
],
"tableData": [
    ["Pune to Mahabaleshwar Urbania on Rent", "Urbania Rental for Pune to Mahabaleshwar Trip"],
    ["Urbania 14-Seater on Rent for Mahabaleshwar", "Urbania for Mahabaleshwar Trip from Pune"],
    ["Pune to Mahabaleshwar Urbania Hire", "Urbania for Group Travel to Mahabaleshwar from Pune"],
    ["Rent Urbania for Mahabaleshwar Sightseeing Tour", "Urbania on Rent Pune to Mahabaleshwar"],
    ["Urbania Rental Price Pune to Mahabaleshwar", "Rent Urbania for Mahabaleshwar Family Trip"],
    ["Pune to Mahabaleshwar Urbania Rental Package", "Urbania Hire for Mahabaleshwar Tour from Pune"],
    ["Mahabaleshwar Trip Urbania on Rent", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Force Urbania Rental Service for Pune to Mahabaleshwar",
        "WhyChoosedescription": "We provide dependable Force Urbania van rentals for comfortable and safe travel between Pune and Mahabaleshwar. Whether it’s a family trip, corporate outing, or group travel, we ensure a smooth and hassle-free journey with professional drivers and timely service."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Force Urbania Vans for Long-Distance Travel",
        "WhyChoosedescription": "Our Force Urbania vans are perfect for long-distance trips like Pune to Mahabaleshwar. With seating options for 9 to 17 passengers, each van comes equipped with comfortable reclining seats, air-conditioning, USB charging ports, and ample legroom, ensuring a pleasant ride throughout your journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers for Safe Travel",
        "WhyChoosedescription": "Our drivers are skilled professionals who prioritize safety, comfort, and punctuality. Familiar with the Pune-Mahabaleshwar route, they ensure smooth navigation through scenic roads and timely arrival at your destination."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing for Pune to Mahabaleshwar Rentals",
        "WhyChoosedescription": "We offer affordable and transparent pricing for Force Urbania rentals between Pune and Mahabaleshwar. Whether you need the van for a few hours or the entire day, our flexible packages ensure you get great value for your travel needs with no hidden charges."
    },
    {
        "WhyChooseheading": "24/7 Availability for Flexible Travel Scheduling",
        "WhyChoosedescription": "Our Force Urbania rental services are available 24/7, so you can plan your journey from Pune to Mahabaleshwar at a time that suits you best. Whether it’s an early morning departure or a late-night return, we ensure that you have reliable transportation whenever you need it."
    },
    {
        "WhyChooseheading": "Easy Booking and Real-Time Updates for Peace of Mind",
        "WhyChoosedescription": "Booking your Force Urbania rental is easy through our website or customer service. Once confirmed, you’ll receive real-time tracking, driver contact details, and updates on the van’s arrival, helping you coordinate your trip without any stress."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized Force Urbania Vans for Your Safety",
        "WhyChoosedescription": "We ensure that our Force Urbania vans are well-maintained and thoroughly sanitized before every trip. This commitment to cleanliness and safety guarantees that you and your passengers have a hygienic and safe environment throughout the journey."
    },
    {
        "WhyChooseheading": "Flexible Payment Options for Convenient Booking",
        "WhyChoosedescription": "We offer multiple payment options including UPI, credit/debit cards, digital wallets, and cash, making it easier for you to complete your booking securely and conveniently."
    }
]





















    }

const faqData = [
    {
        id: 1,
        question: 'How do I book a Force Urbania from Pune to Mahabaleshwar with Samarth Travels?',
        answer: 'You can book a Force Urbania for your Pune to Mahabaleshwar trip by contacting Samarth Travels via our website or phone. Just share your travel dates, number of passengers, and preferred pickup location, and we’ll handle the rest.',
    },
    {
        id: 2,
        question: 'What is the fare for a Pune to Mahabaleshwar Urbania trip?',
        answer: 'The pricing typically starts from ₹10,000 to ₹12,000 for a round trip, depending on the seating capacity (13 or 17-seater) and duration. Charges include vehicle, driver, and fuel for a fixed km limit. Tolls and taxes are extra if applicable.',
    },
    {
        id: 3,
        question: 'Is Force Urbania comfortable for hill station journeys like Mahabaleshwar?',
        answer: 'Yes, Force Urbania is ideal for hill station travel. With pushback recliner seats, air conditioning, large windows, and USB charging ports, it ensures a safe and comfortable journey even on winding roads.',
    },
    {
        id: 4,
        question: 'Can I book Urbania for a same-day return trip to Mahabaleshwar?',
        answer: 'Yes, same-day return trips are available. Let us know your itinerary, and we will provide a suitable rental plan, including driver hours and return scheduling.',
    },
    {
        id: 5,
        question: 'What is the distance and travel time between Pune and Mahabaleshwar?',
        answer: 'The distance is approximately 120 km, and it typically takes about 3.5 to 4.5 hours depending on traffic and route. Our experienced drivers ensure a smooth and safe ride through the ghat sections.',
    },
    {
        id: 6,
        question: 'Can I include sightseeing stops during the Pune to Mahabaleshwar trip?',
        answer: 'Yes, we offer customizable packages. You can include sightseeing stops like Panchgani, Mapro Garden, or Venna Lake. Just inform us in advance to plan your day accordingly.',
    },
    {
        id: 7,
        question: 'Is 24/7 support available for my Pune to Mahabaleshwar Urbania booking?',
        answer: 'Yes, Samarth Travels offers round-the-clock support for all long-distance bookings. Whether you have a question before departure or during the journey, our team is available to assist you.',
    },
];

const testimonials = [
    {
        name: 'Mr. Nilesh Patil',
        role: 'Software Developer',
        text: 'We booked a 17-seater Urbania from Pune to Mahabaleshwar for a weekend getaway. The van was clean and luxurious, and the driver knew the route well. It was a relaxing journey and everyone enjoyed it!',
        image: '/img/testimonial/testi_urbania_nilesh.jpg',
    },
    {
        name: 'Mrs. Anuja Desai',
        role: 'Travel Blogger',
        text: 'Took a 13-seater Force Urbania to Mahabaleshwar with family through Samarth Travels. The ride was smooth, the van was fully equipped, and our driver was very professional. I highly recommend them for scenic drives!',
        image: '/img/testimonial/testi_urbania_anuja.jpg',
    },
];





























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9860256019",
            "+91 9527500025",

        ],
        email: "samarthtravels9119@gmail.com"
    };


   const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " Tempo Traveller Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Tempo Traveller on Rent Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: " Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: " Tempo Traveller on Rent",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Tempo Traveller Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Tempo Traveller Hire in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: " Mini Bus for Rent",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Bus on Rent Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: " Bus on Rent Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: " Bus Rental in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: " Hire Tempo Traveller",
        },
        {
            place: "/images/keyword/12.jpg",
            text: " Bus Hire in Pune",
        },
        {
            place: "/images/keyword/13.jpg",
            text: " Ac Tempo Traveller Rent Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: " Bus Hire For Outstation",
        },
        {
            place: "/images/keyword/15.jpg",
            text: " Bus on Rent for Local",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Bus Rental For Wedding",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Bus Rent for Marriage",
        },
        {
            place: "/images/keyword/18.jpg",
            text: " Bus Rental For Corporate Events",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "  Bus Rental for Tour",
        },

        {
            place: "/images/keyword/20.jpg",
            text: "Bus Rental For Corporate in Pune",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/22.jpg",
            text: " AC Bus On Rent",
        },
        {
            place: "/images/keyword/23.jpg",
            text: " Non Ac Bus Rental Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Bus on Hire on Pune to Mahabaleshwar Package Tour ",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Bus Hire for Picnic",
        },
    ];


    const images = [
        { src: "/images/fleets/1.jpg", alt: "Image 1" },
        { src: "/images/fleets/2.jpg", alt: "Image 1" },
        { src: "/images/fleets/3.jpg", alt: "Image 1" },
        { src: "/images/fleets/4.jpg", alt: "Image 1" },
        { src: "/images/fleets/5.jpg", alt: "Image 1" },
        { src: "/images/fleets/6.jpg", alt: "Image 1" },
        { src: "/images/fleets/7.jpg", alt: "Image 1" },
        { src: "/images/fleets/8.jpg", alt: "Image 1" },
        { src: "/images/fleets/9.jpg", alt: "Image 1" },


    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mahabaleshwar Urbania On Rent",
  "image": "https://samarthtravels.com/assets/images/pune-to-mahabaleshwar-urbania-on-rent.jpg",
  "description": "Rent a luxury Urbania vehicle for your Pune to Mahabaleshwar trip. Affordable rental services for family trips, group travel, sightseeing tours, and more. Comfortable and reliable Urbania for Mahabaleshwar from Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Samarth Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "22000",
    "availability": "https://schema.org/InStock",
    "url": "https://samarthtravels.com/pune-to-mahabaleshwar-urbania-on-rent"
  }
};





    return (
        <div>


<Helmet>
  <title>Pune to Mahabaleshwar Urbania On Rent | Affordable & Luxury Bus Hire | Samarth Travels</title>
  <meta 
    name="description" 
    content="Rent a luxury Urbania vehicle for your Pune to Mahabaleshwar trip. Affordable rental services for family trips, group travel, sightseeing tours, and more. Comfortable and reliable Urbania for Mahabaleshwar from Pune." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mahabaleshwar Urbania on rent, Urbania rental for Pune to Mahabaleshwar trip, Urbania 14-seater on rent for Mahabaleshwar, Urbania for Mahabaleshwar trip from Pune, Pune to Mahabaleshwar Urbania hire, Urbania for group travel to Mahabaleshwar from Pune, Rent Urbania for Mahabaleshwar sightseeing tour, Urbania on rent Pune to Mahabaleshwar, Urbania rental price Pune to Mahabaleshwar, Rent Urbania for Mahabaleshwar family trip, Pune to Mahabaleshwar Urbania rental package, Urbania hire for Mahabaleshwar tour from Pune, Mahabaleshwar trip Urbania on rent" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" data-bg-src="/images/breadcumb-bg.jpg">
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title text-center">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/44.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Samarth Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQSection faqs={faqData} accordionId="drivingAccordion" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword
                                data={testimonials}
                                title="What Our Clients Are Saying"
                                subtitle="Customer Feedback"
                            />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF8F1F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF8F1F' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919860256019" className="d-block  text-white">+91 9860256019</a>
                                                <a href="tel:+919527500025" className="d-block  text-white">+91 9527500025</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:samarthtravels9119@gmail.com" className=" text-white d-block">
                                                    samarthtravels9119@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Samarth Travels <br />
                                                        Flat no 201, Juhi Building, Suyash Shrushti Society, Tukai darshan Hadapsar, Pune- 411028
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomahabaleshwarurbania;